import React from 'react';

export default function EducationWork() {
  return (
    <div className="card--edu--section">
      <div className="presentation--story">
        <div className="nav qualification--tabs mb-5" id="nav-tab" role="tablist">
          <button className="nav--link active" id="pill-work-tab" data-bs-toggle="tab" data-bs-target="#work-tab" role="presentation" aria-controls="pills-work">
            <i className="bi bi-briefcase link--icons"></i>
            Work
          </button>
          <button className="nav--link" id="pill-education-tab" data-bs-toggle="tab" data-bs-target="#education-tab" role="presentation" aria-controls="pills-education">
            <i className="bi bi-mortarboard link--icons"></i>
            Education
          </button>
        </div>
        
        <div className="tab-content qualification_sections" id="tabContent">
          <div className="tab-pane fade" id="education-tab" role="tabpanel" aria-labelledby="pill-education-tab">
            
            <div className="qualification_data">
              <div>
                <h4 className="qualification_title" data-bs-toggle="tooltip" data-bs-placement="right" title="frontend">frontend developer</h4>
                <span className="qualification_subtitle">Start2Impact University</span>
                <div className="qualification_calendar">
                  <i className="bi bi-calendar3 me-2"></i>
                  2022 - active
                </div>
              </div>

              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
            </div>

            <div className="qualification_data">
              <div></div>

              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
              
              <div>
                <h4 className="qualification_title">architecture and<br />urban planning</h4>
                <span className="qualification_subtitle">University of Roma Tre</span>
                <div className="qualification_calendar">
                  <i className="bi bi-calendar3 me-2"></i>
                  2018 - 2021
                </div>
              </div>
            </div>

            <div className="qualification_data">
              <div>
                <h4 className="qualification_title">architektur und<br />städtebau</h4>
                <span className="qualification_subtitle">TUM München (Erasmus+)</span>
                <div className="qualification_calendar">
                  <i className="bi bi-calendar3 me-2"></i>
                  2019 - 2020
                </div>
              </div>

              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
            </div>

            <div className="qualification_data">
              <div></div>

              <div>
                <span className="qualification_rounder"></span>
              </div>

              <div>
                <h4 className="qualification_title">science of architecture</h4>
                <span className="qualification_subtitle">University of Roma Tre</span>
                <div className="qualification_calendar">
                  <i className="bi bi-calendar3 me-2"></i>
                  2015 - 2018
                </div>
              </div>
            </div>
          </div>

          <div className="tab-pane fade show active" id="work-tab" role="tabpanel" aria-labelledby="pill-work-tab">
            <div className="qualification_data">
              <div>
                <h4 className="qualification_title">junior frontend developer</h4>
                <span className="qualification_subtitle">Nesea - NSA Italia, Rome</span>
                <div className="qualification_calendar">
                  <i className="bi bi-calendar3 me-2"></i>
                  2022 - active
                </div>
              </div>

              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
            </div>

            <div className="qualification_data">
              <div></div>

              <div>
                <span className="qualification_rounder"></span>
              </div>

              <div>
                <h4 className="qualification_title">junior architect</h4>
                <span className="qualification_subtitle">DC+A Studio, Rome</span>
                <div className="qualification_calendar">
                    <i className="bi bi-calendar3 me-2"></i>
                    2021 - 2022
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
